import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import "./Hero.css";
import { resolveSiteName } from "../../utils/siteConfig";
import { useLocalContext } from "../../context/LocalContext";

const HERO_IMG =
  "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?q=80&w=2000&auto=format&fit=crop";

const Hero = () => {
  const navigate = useNavigate();
  const { webinfo = {} } = useLocalContext();
  const brand = resolveSiteName(webinfo);

  return (
    <section className="sssHero" aria-label="Hero">
      <div className="sssHero__media" aria-hidden="true">
        <img src={HERO_IMG} alt="" />
        <div className="sssHero__shade" />
        <div className="sssHero__grain" />
      </div>

      <div className="sssHero__content">
        <motion.p
          className="sssHero__brand"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          {brand}
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 22 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.08 }}
        >
          Setup that just works
        </motion.h1>

        <motion.p
          className="sssHero__sub"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.75, delay: 0.16 }}
        >
          Guided printer and Wi‑Fi extender help with live specialists when you need a human.
        </motion.p>

        <motion.div
          className="sssHero__actions"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.24 }}
        >
          <a className="sssHero__btn sssHero__btn--primary" href="/printlab">
            Printer setup
          </a>
          <a className="sssHero__btn sssHero__btn--ghost" href="/wavelab">
            Wi‑Fi extender help
          </a>
          <button type="button" className="sssHero__btn sssHero__btn--text" onClick={() => navigate("/contact")}>
            Talk to an expert
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
